import { render } from "./HZBaseButton.vue?vue&type=template&id=a162b51c&scoped=true"
import script from "./HZBaseButton.vue?vue&type=script&lang=js"
export * from "./HZBaseButton.vue?vue&type=script&lang=js"

import "./HZBaseButton.vue?vue&type=style&index=0&id=a162b51c&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\web\\notigo_base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a162b51c"]])

export default __exports__